import {
    getAction,
    deleteAction,
    putAction,
    postAction
} from '../http'

export default {

    getCompanyById(params = {}) {
        return getAction('/api/design/sys_depart/getCompanyById', params);
    },
    listTeam(params = {}) {
        return getAction(' /api/design/viewTeamCompany/list', params);
    },

    //创建团队
    createTeam: params => postAction('/api/design/sys_depart/add', params),

    //添加成员
    addMemeber: params => postAction('/api/design/sys_user_depart/add', params),
    //删除
    delMemeber: params => deleteAction('/api/design/sys_user_depart/delete', params),
}